import { Row } from "react-bootstrap"
import { useGetDetailedMeasurementsByDeviceQuery } from "../../../../api/rtk/weatherStations/slices/weatherStationsApiSlice"
import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import { HourMeasurementDetailsItem } from "./HourMeasurementDetailsItem"
import { Loader } from "../../../loaders/Loader"

export function HourMeasurementDetailsList() {
    const { deviceId, timeMark } = useAppSelector(state => state.weatherStationsService)
    let { data: hourMeasurementDetails, isFetching } = useGetDetailedMeasurementsByDeviceQuery({ deviceId, timestamp: timeMark }, { skip: !deviceId || !timeMark })

    const hourMeasurementDetailsValues = hourMeasurementDetails?.values

    return (
        <>
            {Array.isArray(hourMeasurementDetailsValues) && hourMeasurementDetailsValues.length > 0
                ?
                <Row xs={1} md={2} lg={3} xl={4} xxl={6} className="hour-measurement-details-list-div gy-3">
                    {hourMeasurementDetailsValues.map((value) => {
                        return <HourMeasurementDetailsItem value={value} />
                    })}
                    {isFetching && <Loader opacity="50%" />}
                </Row>
                :
                <p className="no-hour-measurement-details">Нет данных</p>
            }
        </>
    )
}
